export { ReactComponent as ElementRecording } from './svgs/element-recording.svg';
